export default __webpack_public_path__ + "static/media/discovery.d64fa2d5.png";